var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"881E5E49-C1AD-4EE4-8123-7C8D2B10B725"),React.createElement("g",{"id":"Assety","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Asset:-UI","transform":"translate(-101.000000, -102.000000)","fill":"#0AB14B"},React.createElement("g",{"id":"menu","transform":"translate(101.000000, 102.000000)"},[React.createElement("rect",{"id":"Rectangle","x":"0","y":"0","width":"28","height":"1","rx":"0.5","key":0}),React.createElement("rect",{"id":"Rectangle-Copy","x":"0","y":"5","width":"28","height":"1","rx":"0.5","key":1})])))]);
}

MenuInline.defaultProps = {"width":"28px","height":"6px","viewBox":"0 0 28 6","version":"1.1"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
